module.exports = __webpack_public_path__ + "48cc84e0.png";